import $ from 'jquery';
import _ from 'lodash';
import React from 'react';

const removeEmpty = function (obj) {
  if (obj === null || obj === '') {
    return obj;
  }
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') {
      removeEmpty(obj[key]);
    } else if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  });

  return obj;
};

class JsonApi extends React.Component {
  static callApi(url, filters, pageNumber, pageSize, sortName, sortOrder, callback, error) {
    const params = {
      filter: filters,
      page: {
        size: pageSize,
        number: pageNumber,
      },
      sort: sortName && sortOrder === 'desc' ? `-${sortName}` : sortName,
    };

    return JsonApi.sendGetRequest(
      url,
      params,
      (response) => {
        callback(response);
      },
      (errorResponse) => {
        error(errorResponse);
      }
    );
  }

  static getSelectOptionsRequest(url, filters, labelName, callback, error) {
    const params = { filter: filters };

    return JsonApi.sendGetRequest(
      url,
      params,
      (response) => {
        const result = response.data.map((d) => ({ value: d.id, label: d.attributes[labelName] }));
        callback(result);
      },
      (errorResponse) => {
        error(errorResponse);
      }
    );
  }

  static normalize(json, { camelizeKeys }) {
    const ret = [];

    JsonApi.wrap(json).forEach((elem) => {
      const type = camelizeKeys ? _.camelCase(elem.type) : elem.type;
      const obj = {};
      obj.type = type;
      obj.id = elem.id;

      if (camelizeKeys && elem.attributes) {
        Object.keys(elem.attributes).forEach((key) => {
          obj[_.camelCase(key)] = elem.attributes[key].trim();
        });
      } else if (elem.attributes) {
        Object.keys(elem.attributes).forEach((key) => {
          obj[key] =
            typeof elem.attributes[key] === 'string'
              ? elem.attributes[key].trim()
              : elem.attributes[key];
        });
      } else {
        Object.keys(elem).forEach((key) => {
          obj[key] = typeof elem[key] === 'string' ? elem[key].trim() : elem[key];
        });
      }

      if (elem.links) {
        obj.links = {};

        Object.keys(elem.links).forEach((key) => {
          obj.links[key] = elem.links[key];
        });
      }

      if (elem.relationships) {
        obj.relationships = $.extractRelationships(elem.relationships, { camelizeKeys });
      }

      ret.push(obj);
    });

    return ret;
  }

  static normlizeComparator(symbol) {
    switch (symbol) {
      case '>':
        return 'gt';
      case '>=':
        return 'gte';
      case '<':
        return 'lt';
      case '<=':
        return 'lte';
      case '!=':
        return 'ne';
      default:
        return null;
    }
  }

  static sendDeleteRequest(url, params, body, callback, error) {
    // clean unwanted params
    removeEmpty(params);

    // ajax call
    return $.ajax({
      url: JsonApi.urlParamsMerge(url, params),
      type: 'DELETE',
      dataType: 'json',
      data: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
      success: callback,
      error,
    });
  }

  static sendGetRequest(url, params, callback, error) {
    // clean unwanted params
    removeEmpty(params);

    // ajax call
    return $.ajax({
      url: JsonApi.urlParamsMerge(url, params),
      type: 'GET',
      success: callback,
      error,
    });
  }

  static sendPatchRequest(url, params, body, callback, error) {
    // clean unwanted params
    removeEmpty(params);

    // ajax call
    return $.ajax({
      url: JsonApi.urlParamsMerge(url, params),
      type: 'PATCH',
      dataType: 'json',
      data: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
      success: callback,
      error,
    });
  }

  static sendPostFormData(url, params, body, callback, error) {
    // clean unwanted params
    removeEmpty(params);

    // ajax call
    return $.ajax({
      url: JsonApi.urlParamsMerge(url, params),
      method: 'POST',
      type: 'POST',
      cache: false,
      contentType: false,
      processData: false,
      data: body,
      success: callback,
      error,
    });
  }

  static sendPostRequest(url, params, body, callback, error) {
    // clean unwanted params
    removeEmpty(params);

    // ajax call
    return $.ajax({
      url: JsonApi.urlParamsMerge(url, params),
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' },
      success: callback,
      error,
    });
  }

  static urlParamsMerge(url, params) {
    if (params === null || params === '') {
      return url;
    }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + $.param(params);
  }

  static wrap(json) {
    if (Array.isArray(json)) {
      return json;
    }

    return [json];
  }
}

export default JsonApi;
